import { DataGrid } from "@mui/x-data-grid";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  collection,
  query,
  where,
  orderBy,
  limit,
  getDocs,
  startAfter,
  onSnapshot,
} from "firebase/firestore";
import { db } from "../../firebase";
import { userColumns } from "./datatablesource";
import { Typography } from "@mui/material";

const Datatable = () => {
  const [data, setData] = useState([]);
  const [lastDoc, setLastDoc] = useState(null); // For pagination (last fetched document)
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const uid = queryParams.get("uid");

  // Fetch initial data with pagination and timestamp descending
  const fetchData = async () => {
    setLoading(true);
    try {
      const paymentsRef = collection(db, "withdraw_request");

      // Initial query with or without user ID, ordered by 'timestamp' in descending order
      let q = query(paymentsRef, orderBy("timestamp", "desc"), limit(10));

      if (uid) {
        q = query(paymentsRef, where("user_id", "==", uid), orderBy("timestamp", "desc"), limit(10));
      }

      const snapshot = await getDocs(q);
      const list = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setData(list); // Set the fetched data to state
      setLastDoc(snapshot.docs[snapshot.docs.length - 1]); // Store the last document for pagination
      setLoading(false);
    } catch (error) {
      console.error("Error fetching payments:", error);
      setLoading(false);
    }
  };

  // Fetch more data for pagination
  const fetchMoreData = async () => {
    if (!lastDoc) return; // No more data to fetch
    setLoading(true);
    try {
      const paymentsRef = collection(db, "withdraw_request");

      // Next query starting after the last document, maintaining timestamp descending order
      let q = query(paymentsRef, orderBy("timestamp", "desc"), startAfter(lastDoc), limit(10));

      if (uid) {
        q = query(paymentsRef, where("user_id", "==", uid), orderBy("timestamp", "desc"), startAfter(lastDoc), limit(10));
      }

      const snapshot = await getDocs(q);
      const list = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setData((prevData) => [...prevData, ...list]); // Append the new data to the existing data
      setLastDoc(snapshot.docs[snapshot.docs.length - 1]); // Update the last document for pagination
      setLoading(false);
    } catch (error) {
      console.error("Error fetching more payments:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(); // Initial data fetch
  }, [uid]); // Fetch data again when uid changes

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 60,
      renderCell: (params) => (
        <div className="cellAction">
          <Link
            to={`/paymentrequest/fullview?uid=${params.row.id}`}
            style={{ textDecoration: "none" }}
          >
            <div className="viewButton">View</div>
          </Link>
        </div>
      ),
    },
  ];

  return (
    <div className="datatable">
      {uid && (
        <Typography variant="body" component="h4" gutterBottom>
          My Transactions || User ID: {uid}
        </Typography>
      )}
      <DataGrid
        className="datagrid"
        rows={data}
        columns={[...userColumns, ...actionColumn]}
        pageSize={9}
        rowsPerPageOptions={[9]}
        checkboxSelection
      />
      {!loading && lastDoc && (
        <button onClick={fetchMoreData} className="loadMoreButton">
          Load More
        </button>
      )}
      {loading && <p>Loading...</p>}
    </div>
  );
};

export default Datatable;
